export default __webpack_public_path__ + "static/media/Prog Slyszalnosci i Bolu.bed07c14.png";